<template>
  <div class="md-layout" v-if="users && users.length > 0">
    <div class="md-layout-item stacked-users-container">
      <div class="md-layout stacked-avatars">
        <div
          v-for="(participant, index) in users.slice(0, maxLength)"
          :key="index"
          class="md-layout-item avatars single-user">
          <img class="participant-image" :src="participant.image || participant.userImage || defaultImage">
          <md-tooltip md-direction="top">{{ participant.displayName || participant.userDisplayName }}</md-tooltip>
        </div>
      </div>

      <div v-if="users.length > maxLength && showUserCount" class="md-layout-item">
        <md-button
            :disabled="disableCountClick"
            class="md-round md-just-icon md-simple count-button"
            @click="toggleModal"
        >
          +{{ users.length - maxLength }}
        </md-button>
      </div>
      <div v-if="!showUserCount" class="md-layout-item users-name">
        <span class="user-list">{{users[0].displayName || users[0].userDisplayName}} {{this.$t('general.and')}} {{users.length - 1}} {{this.$t('teams.friendsAreMembers')}}</span>
      </div>
    </div>
    <div
      v-if="displayText"
      class="md-layout-item md-size-100 invited-text"
    >
      Schon eingeladen
    </div>

  </div>
</template>

<script>
export default {
  name: 'StackedUsers',
  props: {
    disableCountClick: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Array,
      default: new Array()
    },
    displayText: {
      type: Boolean,
      default: false,
    },
    showUserCount: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      maxLength: 4,
      defaultImage: this.$store.state.defaultAvatar,
    }
  },
  methods: {
    toggleModal() {
      this.$emit('openModal');
    },
  }
}
</script>

<style lang="scss">
.stacked-users-container {
  flex: 1 1 100%;
  display: flex;
  padding: 0;
  .stacked-avatars {
    display: contents;
  }
  .users-name {
    margin-left: 10px;
  }
  .participant-image {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px;
    border-radius: 50%;
    border: 2px solid white;
  }
  .user-list {
    font-size: 12px;
    font-weight: 400;
    display: flex;
    color: #AA9E9E;
    text-align: initial;
    line-height: 18px;
  }

  .count-button {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    margin: 0;
    border: 1px solid #005FB6;

    .md-button-content {
      color: #005FB6 !important;
      font-size: 18px;
    }
  }

  .invited-text {
    display: flex;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: #AA9E9E;
  }

  .single-user {
    padding: 0;
    width: 20px;
    flex: 0 0 auto;
  }
}
</style>
